module.exports = __webpack_public_path__ + "static/superman-da3b5053f0e2b697e4f690df394e7773.svg";